import React, { useState, useRef, useMemo, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { WocommercePriceEditAddForm } from "./WocommercePriceEditAddForm";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { createWocommercePricing, fetchSingleWocommerce, updateWocommercePricing } from "../../../actions/wocommerce-pricing/wocommerce";

export function WocommercePriceEdit({
  history,
  match: {
    params: { id },
  },
}) {

  const { enqueueSnackbar } = useSnackbar();

  const initWocommerceInfo = {
    plan_name: "",
    plan_type:"",
    plan_desc: "",
    plan_price:"",
    inventory_type:"",
    plan_inventory:""
  };

  const { wocommerceForEdit } = useSelector(
    (state) => ({
      wocommerceForEdit: id ? state.wocommercePricing?.wocommerceForEdit : undefined,
    }),
    shallowEqual
  );

  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!id) {
      suhbeader.setBreadcrumbs([{pathname:'/wocommerce-price', title:'Price'},{pathname:'', title:'Add Price'}]);
    } else {
      suhbeader.setBreadcrumbs([{pathname:'/wocommerce-price', title:'Price'},{pathname:'', title:'Edit Price'}]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

    await dispatch(fetchSingleWocommerce(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  // set Title
  useMemo(() => {
    let _title = id ? "" : "Add Wocommerce Price";
    suhbeader.setTitle(_title);
    setTitle(_title);

    if (id) {
      _title = "Edit Wocommerce Price";
      setTitle(_title);
      suhbeader.setTitle(_title);
    }
    return {
      _title,
    };
  }, [id, suhbeader]);

  const saveWocommerceInfo = (values) => {
    setIsLoading(true);
    if (!id) {
      dispatch(createWocommercePricing(values)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/wocommerce-price`);

            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });
            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        }
      });
    } else {
      dispatch(updateWocommercePricing(values, id)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/wocommerce-price`);
            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });

            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        }
      });
    }
  };

  const btnRef = useRef();
  const saveWocommerceButtonClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/wocommerce-price`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}

      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveWocommerceButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              to={history.location.pathname}
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Basic info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <WocommercePriceEditAddForm
              wocommerce = {wocommerceForEdit||initWocommerceInfo}
              id={id}
              btnRef={btnRef}
              saveWocommerceInfo={saveWocommerceInfo}
            />
          )}
          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title=''>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveWocommerceButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
